module.exports = __webpack_public_path__ + "static/meeting-6e4107adcb99f7bb08d25d5f208efb93.jpg";